<div class="" id="guideModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog-2">
        <div class="modal-content-2">
            <div class="modal-body-2">
                <button style="float: right;" type="button" class="close" (click)="onClose()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="header">
                    <!-- <mat-icon><span class="material-symbols-outlined">
                waving_hand
              </span></mat-icon> -->
                    <img src="../../../assets/image/emoji-hands-victory-icon-3d-model-low-poly-max-bip-obj-mtl-3ds-fbx (1) 1.svg"
                        alt="Hand Emoji">
                </div>
                <div class="heading">
                    <p>Welcome to Songdew!</p>
                    <p>Ready to elevate your Music Career?</p>
                </div>
                <div class="sub-heading">
                    <p>Songdew helps you Distribute, Promote & Monetize your music.</p>
                </div>
                <div class="buttons">
                    <button type="button" class="btn btn-start" (click)="startTour()" data-dismiss="modal">Start a Quick
                        Tour</button>
                    <button type="button" class="btn btttn" (click)="onClose()">No Thanks</button>
                </div>
            </div>
        </div>
    </div>
</div>